/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'back-to': {
    width: 244.531,
    height: 200,
    viewBox: '0 0 1252 1024',
    data: '<defs/><path pid="0" d="M175 1023.943V882.309h616.889c39.207 0 78.26-1.909 116.838-9.43 40.83-7.94 79.655-20.996 114.681-44.017 45.258-29.72 74.997-71.065 89.428-122.908 19.413-69.595 18.974-139.343-4.448-207.965-18.916-55.355-56.538-94.867-109.03-120.255A333.794 333.794 0 00883.13 346.01c-29.663-2.71-59.536-3.818-89.332-4.104-81.278-.534-162.555-.19-243.85-.19h-8.266v199.928L0 270.726 541.3 0v200.654h8.723c87.405 0 174.847-.706 262.252.44 71.828.934 142.454 10.822 210.16 36.572 101.167 38.481 169.884 108.21 204.128 211.248 15.958 47.968 22.657 97.483 24.414 147.818.171 5.23.744 10.441 1.145 15.671v22.906c-.306 2.71-.783 5.402-.86 8.113-1.316 42.432-6.718 84.254-18.362 125.141-13.781 48.408-35.771 92.482-69.442 130.295-44.686 50.164-101.167 81.03-164.845 99.717-55.928 16.435-113.326 23.23-171.488 24.432-7.368.153-14.736.65-22.104.993z"/>'
  }
})
